// @flow

import type { Action } from './store.type';

export const GET_SEARCH_SETTINGS_REQUEST = 'GET_SEARCH_SETTINGS_REQUEST';
type GET_SEARCH_SETTINGS_REQUEST_TYPE = 'GET_SEARCH_SETTINGS_REQUEST';

export const GET_SEARCH_SETTINGS_SUCCESS = 'GET_SEARCH_SETTINGS_SUCCESS';
type GET_SEARCH_SETTINGS_SUCCESS_TYPE = 'GET_SEARCH_SETTINGS_SUCCESS';

export const GET_SEARCH_SETTINGS_FAILURE = 'GET_SEARCH_SETTINGS_FAILURE';
type GET_SEARCH_SETTINGS_FAILURE_TYPE = 'GET_SEARCH_SETTINGS_FAILURE';

export const UPDATE_SEARCH_SETTINGS_REQUEST = 'UPDATE_SEARCH_SETTINGS_REQUEST';
type UPDATE_SEARCH_SETTINGS_REQUEST_TYPE = 'UPDATE_SEARCH_SETTINGS_REQUEST';

export const UPDATE_SEARCH_SETTINGS_SUCCESS = 'UPDATE_SEARCH_SETTINGS_SUCCESS';
type UPDATE_SEARCH_SETTINGS_SUCCESS_TYPE = 'UPDATE_SEARCH_SETTINGS_SUCCESS';

export const UPDATE_SEARCH_SETTINGS_FAILURE = 'UPDATE_SEARCH_SETTINGS_FAILURE';
type UPDATE_SEARCH_SETTINGS_FAILURE_TYPE = 'UPDATE_SEARCH_SETTINGS_FAILURE';

type SearchSettingsSuccess = {
  data: Object
};

type SearchSettingsFailure = {
  error: any
};
type GetSearchSettingsRequestAction = Action<GET_SEARCH_SETTINGS_REQUEST_TYPE, null>;

type GetSearchSettingsSuccessAction = Action<
  GET_SEARCH_SETTINGS_SUCCESS_TYPE,
  SearchSettingsSuccess
>;

type GetSearchSettingsFailureAction = Action<
  GET_SEARCH_SETTINGS_FAILURE_TYPE,
  SearchSettingsFailure
>;

type UpdateSearchSettingsRequestAction = Action<UPDATE_SEARCH_SETTINGS_REQUEST_TYPE, null>;

type UpdateSearchSettingsSuccessAction = Action<
  UPDATE_SEARCH_SETTINGS_SUCCESS_TYPE,
  SearchSettingsSuccess
>;

type UpdateSearchSettingsFailureAction = Action<
  UPDATE_SEARCH_SETTINGS_FAILURE_TYPE,
  SearchSettingsFailure
>;

export type SearchSettingsAction =
  | GetSearchSettingsRequestAction
  | GetSearchSettingsSuccessAction
  | GetSearchSettingsFailureAction
  | UpdateSearchSettingsRequestAction
  | UpdateSearchSettingsSuccessAction
  | UpdateSearchSettingsFailureAction;

export type SearchSettingsState = {
  getLoading: boolean,
  updateLoading: boolean,
  success: boolean,
  error: any,
  searchSettings: {}
};
